import React from 'react';

const MarketPanelIndian = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Indian Market</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="indian-market">
            <thead>
              <tr>
                <th>Index Name</th>
                <th>Day Change</th>
                <th>Open Percentage</th>
                <th>High</th>
                <th>Last Traded</th>
                <th>Change Percentage</th>
                <th>Low</th>
                <th>Change</th>
                <th>Outlook</th>
                <th>Open</th>
                <th>Prev. Close</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.index_name}</td>
                    <td>{item.index_data?.day_change || '-'}</td>
                    <td>{item.index_data?.open_percentage || '-'}</td>
                    <td>{item.index_data?.high || '-'}</td>
                    <td>{item.index_data?.last_traded || '-'}</td>
                    <td>{item.index_data?.change_percentage || '-'}</td>
                    <td>{item.index_data?.low || '-'}</td>
                    <td>{item.index_data?.change || '-'}</td>
                    <td>{item.index_data?.outlook || '-'}</td>
                    <td>{item.index_data?.open || '-'}</td>
                    <td>{item.index_data?.prev_close || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelIndian; 